import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, FunnelIcon } from '@heroicons/react/24/outline';

interface FilterAccordionProps {
  title?: string;
  /** Aktív szűrők száma — a fejlécen jelzőként jelenik meg */
  activeCount?: number;
  /** Ha az értéke megváltozik (pl. keresés indult), mobilon összecsukja a panelt */
  collapseKey?: unknown;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

/**
 * Mobilon (md alatt) accordionként összecsukható szűrőpanel; desktopon a fejléc
 * el van rejtve és a tartalom mindig látszik.
 */
const FilterAccordion: React.FC<FilterAccordionProps> = ({
  title = 'Szűrők',
  activeCount,
  collapseKey,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setOpen(false);
  }, [collapseKey]);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between rounded-lg px-1 py-2 text-sm font-medium text-gray-700 md:hidden"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2">
          <FunnelIcon className="h-4 w-4 text-gray-400" />
          {title}
          {activeCount !== undefined && activeCount > 0 && (
            <span className="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-primary-600 px-1.5 text-xs font-semibold text-white">
              {activeCount}
            </span>
          )}
        </span>
        <ChevronDownIcon
          className={`h-4 w-4 text-gray-400 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
        />
      </button>
      <div
        className={`overflow-hidden transition-[max-height,visibility] duration-300 ease-in-out md:visible md:max-h-none md:overflow-visible ${
          open ? 'visible max-h-[2000px]' : 'invisible max-h-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default FilterAccordion;
